<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between align-items-center catalogo-text text-sm"
          >
            Catálogo de cultivos
            <router-link :to="{ name: 'NuevoCultivo' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Cultivo
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #variedad="{item}">
                <td class="py-2">{{ item.payload.variedad }}</td>
              </template>
              <template #embalaje="{item}">
                <td class="py-2">
                  {{ item.payload.embalajes.map(e => e.nombre).join(",") }}
                </td>
              </template>
              <template #over-table>
                <CInput
                  v-model="filter"
                  @input="searchTimeOut()"
                  placeholder="Búsqueda por cultivos..."
                />
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'EditarCultivo',
                      params: { id: item.id }
                    }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                  <!-- <CButton color="success" square size="sm" @click="toggleEdit(index, item)">Editar</CButton> -->
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Cultivo"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el cultivo {{ itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Cultivo</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteCultivo(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
const fields = [
  { key: "nombre", label: "Cultivo", _style: "width:40%" },
  { key: "variedad", label: "Variedad", _style: "width:1%"},
  { key: "embalaje", label: "Embalaje", _style: "width:40%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Cultivos",

  data() {
    return {
      items: [],
      fields,
      filter: "",
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      isLoading: false,
      error: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.isLoading = true;
    this.$store
      .dispatch("customHTTP", {
        schema: "cultivos",
        limit: 50,
        page: 1,
        ["with-storage"]: ["*"]
      })
      .then(res => {
        this.items = res.data;
        this.pages = res.paginate.last_page;
        this.page = res.paginate.current_page;
      })
      .catch(err => console.log(err))

      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      return this.items.filter(i =>
        i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text, page=1) {
      this.isLoading = true;
      const catalogo = [
        this.$store.dispatch("customHTTP", {
          schema: "cultivos",
          limit: 50,
          page: page,
          filter: {
            orwhere: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "payload->variedad",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "payload->embalajes->*->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        })
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.updateItemsSearch(this.filter.toUpperCase(), event)
    },

    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteCultivo(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "cultivos",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
